import { Entry } from '../Entry'

export function Entry20220510() {
  return (
    <Entry title="10/05/2022 - v3.0.6">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12590/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
